import { takeLatest, call, select } from 'redux-saga/effects';
import { findPastedDeviation } from './actionCreators';
import { request } from '../../../xhr';
import { getPrimaryTier, isDeviationAuthor } from '../../../DeviationViews/_helpers';
import { normalizePremiumFolderData } from '../../../utils/normalizePremiumFolderData';
import { getCurrentUser } from '../../../publicSession/selectors';
export function fakeResponse(options) {
    if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line
        const deviations = require('@wix/da-sample-data').deviationsByType.image;
        return deviations[Math.round(Math.random() * (deviations.length - 1))];
    }
}
function* fetchDeviation(deviationLookup) {
    const result = yield call(request, {
        method: 'get',
        url: `/deviation/fetch`,
        params: {
            deviationid: deviationLookup.id,
            type: deviationLookup.type,
            username: deviationLookup.username
        }
    }, fakeResponse);
    return result;
}
export function* doFindDeviation(action) {
    const { deviationLookup, setEntityData } = action.payload;
    const currentUser = yield select(getCurrentUser);
    const deviationResult = yield call(fetchDeviation, deviationLookup);
    if (deviationResult && !deviationResult.error) {
        const isInTier = getPrimaryTier(deviationResult);
        const isOwner = isDeviationAuthor(deviationResult, currentUser);
        const { isPremium } = normalizePremiumFolderData(deviationResult.premiumFolderData);
        const isForbidden = isPremium || isInTier && !isOwner;
        if (!isForbidden) {
            return setEntityData(deviationResult);
        }
    }
    setEntityData(undefined);
}
export default function* saga() {
    yield takeLatest(findPastedDeviation, doFindDeviation);
}
